// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "pdfjs" + "." + "d96a7ee3" + ".chunk.css");